export default {
	namespaced: true,
	state: {
		selectedInvoices: [],
	},
	actions: {
	},
	mutations: {
		setSelectedInvoices(state, payload) {
			state.selectedInvoices = payload;
		},
	}
}
